<script>
import { watchViewport, unwatchViewport } from "tornis";

import Logo from "@/components/ui/Logo";
import MenuMain from "@/components/menu/MenuMain";

export default {
  name: "PageHeader",
  components: {
    Logo,
    MenuMain
  },
  computed: {
    navigation() {
      return this.$store.state.navigation;
    },
    classes() {
      return [
        "site-header",
        {
          sticky: this.navigation.sticky,
          open: this.navigation.open
        }
      ];
    }
  },
  mounted() {
    watchViewport(this.watchSticky.bind(this));
  },
  beforeDestroy() {
    unwatchViewport(this.watchSticky.bind(this));
  },
  methods: {
    watchSticky({ scroll }) {
      if (scroll.changed) {
        const isSticky = scroll.top > 0;
        if (!this.navigation.open && isSticky !== this.navigation.sticky) {
          this.$store.commit("updateNavigation", { sticky: isSticky });
        }
      }
    }
  }
};
</script>

<style lang="stylus" scoped>
@import "PageHeader"
</style>
